module.exports = __webpack_public_path__ + "img/03_2.2e4efcec.png";